import { theme as chakraBaseTheme } from '@chakra-ui/theme';

/**
 * Mathletics color theme color design tokens.
 * Taken from Figma mui poc, see links.
 *
 * Each time a new token is added we need to run the chakra cli to generate types,
 * this should happen automatically for consumers of this module via
 * postinstall hook, as per chakra doc link below scaling-out-your-project.
 *
 * @see official base theme https://github.com/chakra-ui/chakra-ui/blob/684012d868516412e91eb390379ccf7698536345/packages/theme
 * @see https://www.figma.com/file/0KEmygotdgKlMajCrLbx7c/DS---MUI?node-id=5051%3A20799
 * @see https://chakra-ui.com/docs/theming/customize-theme#scaling-out-your-project
 */
export const primary = {
    50: '#EEF8FE',
    100: '#D0F1FD',
    200: '#BCEAFD',
    300: '#99DDF6',
    500: '#00ABE8',
    600: '#007ACC',
    700: '#0063A7',
    800: '#004786',
    900: '#00336F'
};

export const secondary = {
    0: '#FFFFFF',
    50: '#FFFAEE',
    100: '#FEF3D6',
    200: '#FEE8AD',
    400: '#F9D258',
    500: '#F4BC22',
    600: '#E4AB10',
    700: '#A56A00',
    800: '#854C00',
    900: '#653A00'
};

export const neutral = {
    25: '#F8FBFC',
    50: '#F4F8FA',
    100: '#EDF1F4',
    200: '#DBE0E6',
    300: '#CBD3DC',
    400: '#ADB9C7',
    500: '#838F9E',
    600: '#5C6C7F',
    700: '#33475F',
    800: '#1A304B',
    900: '#001937'
};

export const success = {
    50: '#F6FEF4',
    100: '#DEF6DE',
    200: '#BCEDBD',
    300: '#9BE49D',
    400: '#58D25B',
    500: '#29B539',
    600: '#1D9B37',
    700: '#148235',
    800: '#0D6830',
    900: '#024D1F'
};

export const error = {
    50: '#FEF6F7',
    100: '#FDEEEF',
    200: '#FBDFE1',
    300: '#F6BFC3',
    400: '#F0939B',
    500: '#EB6973',
    600: '#E22837',
    700: '#C51B29',
    800: '#A21622',
    900: '#81000B'
};

export const warning = {
    50: '#FFF5F0',
    100: '#FDEEEF',
    200: '#FDCBB5',
    300: '#FDEEEF',
    400: '#FB986B',
    500: '#FA7E46',
    600: '#E4642A',
    700: '#CC461B',
    800: '#BA3409',
    900: '#972500'
};

export const teal = {
    100: '#E7FDF8',
    200: '#CFFBF4',
    300: '#B3F3EE',
    400: '#9CE5E7',
    500: '#7ACED7',
    600: '#59A7B8',
    700: '#3D829A',
    800: '#265F7C',
    900: '#103A59'
};

export const orchid = {
    100: '#FBD7F4',
    200: '#F8B0F0',
    300: '#EA84E6',
    400: '#CF61D5',
    500: '#A833B9',
    600: '#85259F',
    700: '#661985',
    800: '#4A106B',
    900: '#350958'
};

// Material-ui like circle animation for RippleButton / RippleIconButton
export const ripples = {
    // primary.200
    backgroundColor: '#97F7FC'
};

// Include the base Chakra colors, UX has not completed modifying chakra theme.
// this destructuring removes the colors not being used.
// No other api seem for this atm @see https://github.com/chakra-ui/chakra-ui/issues/4711
const {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    twitter, facebook, whatsapp, messenger, linkedin, telegram,
    ...baseColors
} = chakraBaseTheme.colors;

export const colors = {
    ...baseColors,
    // Include the current custom colours as per Figma design
    warning,
    error,
    success,
    neutral,
    secondary,
    primary,
    ripples
};
